import { Slider } from '@mui/material'
import React from 'react'
import AlertElement from '../../components/AlertElement'

interface IProps {
    itemMaxAvailableQnt: number,
    quantity: number,
    updateQuantity: (qnt: number) => void,
    allowZero?: boolean,

}

export default function QuantitySlider(props: IProps) {

    const { itemMaxAvailableQnt, quantity, updateQuantity, allowZero } = props

    const handleChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number') {
            updateQuantity(newValue)
        }
    }

    const generateMarks = (max: number) =>
        Array.from({ length: max }, (_, i) => ({
          value: i + 1,
          label: String(i + 1),
    }))

    if (itemMaxAvailableQnt === 0){
        return <AlertElement type="error" message="Not enough availbale quantity." />
    }

    return(
        <div className="quantity-selector-box">
            <div className="content-of-quantity-selector-box">

                <h3 className="title-of-quantity-selector-box">Select quantity</h3>

                <div className="selected-amount-box-of-quantity-selector-box">
                    <div className="content-of-selected-amount-box-of-quantity-selector-box">
                        <p>{quantity}</p>

                        <div className="label-box-of-selected-amount-box-of-quantity-selector-box">
                            <div className="content-of-label-box-of-selected-amount-box-of-quantity-selector-box">
                                <span>Selected Quantity</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="slider-qnt-box">
                    <div className="content-of-slider-qnt-box">
                        <Slider
                            value={quantity}
                            onChange={handleChange}
                            aria-labelledby="quantity-slider"
                            valueLabelDisplay="auto"
                            step={1}
                            marks
                            min={allowZero ? 0 : 1}
                            max={itemMaxAvailableQnt}
                            // @ts-ignore
                            // marks={generateMarks(itemMaxAvailableQnt)} 
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}
